module.exports = __webpack_public_path__ + "assets/fullcalendar.470873dc.svg";